export enum DocumentType {
  ID = 'ID',

  PASSPORT = 'PASSPORT',
}
